import { getExerciseTypeVersionAdapter } from '@datacamp/exercise-types';
var exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('ChatExercise', 'v0');
export default exerciseTypeVersionAdapter;